<template>
  <TitleWrapper
    title="STAFF"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />

  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <StaffPermission />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <StaffNotification />
  </div>
</template>

<script>
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import StaffNotification from '@src/router/views/settings/notifications/staff/StaffNotification.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import StaffPermission from '@src/router/views/settings/system-settings/StaffPermission.vue'
import UITabs from '@src/components/UiElements/UITabs.vue'
import TitleWrapper from '@components/TitleWrapper.vue'

export default {
  name: 'Settings',
  components: {
    UITabs,
    TitleWrapper,
    NoRecordFound,
    StaffNotification,
    StaffPermission,
  },

  page: {
    title: 'Features Settings',
  },

  data() {
    return {
      FEATURES_TABS,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
}
</script>
